@if (isUnsupportedOperationType()) {
    <tec-empty-state
        [title]="'OPERATIONS.DETAIL.TABS.ACTIVITY.UNSUPPORTED' | translate"
        [size]="'default'"
        [type]="'empty'"
    />
} @else {
    <app-list-operations-activity [data]="detail?.activity" [logs_url]="detail?.logs_url" />
}

